import React, { useEffect } from "react";
import { FaFacebook, FaGoogle, FaInstagram, FaRss, FaTwitter } from "react-icons/fa";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  useEffect(() => {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;      
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  return (
    <div>
      <div id='fb-root'></div>
      <footer className='copy-right-bg'>
        <Container>
          <Row>
            <Col md='12' className='text-center'>
              <div className='social-footer'>
                <ul>
                  <li><FaFacebook className="text-white"/></li>
                  <li><FaGoogle className="text-white"/></li>
                  <li><FaTwitter className="text-white"/></li>
                  <li><FaInstagram className="text-white"/></li>
                  <li><FaRss className="text-white"/></li>
                </ul>
              </div>
            </Col>
            <Col md='12' className='text-center'>
              <p className='copyright'>2024-25 Copyright by themeforest Powered by Pixelstrep</p>
            </Col>
          </Row>
        </Container>
      </footer>
      {/* Your customer chat code */}
      <div className='fb-customerchat' page_id='2123438804574660' theme_color='#5f57ea' logged_in_greeting='Hi! Welcome to PixelStrap Themes. How can we help you?' logged_out_greeting='Hi! Welcome to PixelStrap Themes. How can we help you?'></div>
    </div>
  );
};

export default Footer;
